"use client";

import { Footer } from "@components/TokenDetails/Footer";
import React from "react";
import { DeviceType } from "utils/src/uaDevicesParse/ua-device-parser";
import { DocsBack } from "../components/AIInsight/DocsBack";
import { DocsDetailPageServersData } from "./types";
import { Locale } from "@utils/i18n.locale";
import type { AIInsightContentTabType } from "@components/AIInsight/types";
import { DocsDetailArticle } from "./DocsDetailArticle";

interface DocsDetailPageProps {
  serverData: DocsDetailPageServersData;
  locale: Locale;
  category: string;
  contentType: AIInsightContentTabType;
  deviceType: DeviceType;
}

export const DocsDetailPage = ({
  serverData,
  category,
  contentType,
  locale,
  deviceType: deviceTypeServer,
}: DocsDetailPageProps) => {
  const deviceType = deviceTypeServer === "desktop" ? "desktop" : "mobile";

  return (
    <div>
      <div className="w-full flex flex-col items-center px-4 md:px-0">
        {deviceType !== "mobile" && (
          <div className="w-full flex justify-start">
            <DocsBack />
          </div>
        )}
        <DocsDetailArticle
          serverData={serverData}
          category={category}
          contentType={contentType}
          locale={locale}
          deviceType={deviceTypeServer}
          mode="full"
        />
      </div>
      <Footer locale={locale} className="mt-6" />
    </div>
  );
};
